import React from 'react';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Modal from '../components/Modal';
import BasePage from './BasePage';
import $ from 'jquery';

class ChangePassword extends BasePage {

    loadOnConstructor(){
        this.changePasswordForm = this.changePasswordForm.bind(this);
        this.changePasswordCallBack = this.changePasswordCallBack.bind(this);
        this.getRecoverData = this.getRecoverData.bind(this);
        this.parseResponse = this.parseResponse.bind(this);

        this.state = {};

	const {recover_id} = this.getUrlParams();
	if(recover_id === undefined){
		this.props.setModalContent({
			title: 'Mensaje del servidor',
			body: ['Hubo un problema con la recuperaciónn de su password, vuelva a intentarlo de nuevo, por favor.'],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

		setTimeout(() => {
			$("#exampleModal").modal('toggle');
		}, 500);
	}else{

        	this.state = {
				password_recovery: recover_id
        	};

		this.getRecoverData(recover_id);
	}
    }

    getRecoverData(recover_id){
	const api = this.getApi();
	api.checkRecoveryData(recover_id, this.parseResponse);
    }

    parseResponse(response){

	    if(response.status === 'OK'){

		    this.setState(prevState => {
			    return {
				...prevState,
				passwordRecovery: response.passwordRecovery
			    }
		    });
	    }else{
		    this.props.setModalContent({
			    title: 'Mensaje del servidor',
			    body: ['Hubo un problema con la recuperaciónn de su password, vuelva a intentarlo de nuevo, por favor.'],
			    buttons: [
			    	{shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });
		    $("#exampleModal").modal('toggle');

	    }
    }

    render() {
        return (
            <>
<div className="wrapper fadeInDown">
  <div id="formContent">

    <div className="fadeIn first">
      {/*<img src="http://danielzawadzki.com/codepen/01/icon.svg" id="icon" />*/}
    </div>

    <div id="formFooter">
        <label>Para recuperar su cuenta rellene los siguientes campos, por favor</label>
    </div>

    <form onSubmit={this.changePasswordForm} className="mt-4">
	           <input 
 			className="fadeIn second login"         		
                        type="password"
                        name="new_password"
                        placeholder="Nuevo password" 
                        ref={(c) => this.newPassword = c} 
                    />

                    <input 
 			className="fadeIn second login"         		
                        type="password"
                        name="confirm_password"
                        placeholder="Confirme su password" 
                        ref={(c) => this.confirmPassword = c} 
                    />

      <input type="submit" className="fadeIn fourth mt-4 login" value="Enviar" />
    </form>

  </div>
</div>

                <Modal />
            </>
        )
    }

    changePasswordForm(e){
        e.preventDefault();

	if(this.newPassword.value === this.confirmPassword.value){

		const arrayParams = [
			{name: "new_password", value: this.newPassword.value},
			{name: "password_recovery", value: this.state.password_recovery}
		];

		const api = this.getApi();
		api.changePassword(arrayParams, this.changePasswordCallBack);
	}else{
		this.props.setModalContent({
			title: 'Mensaje del servidor',
			body: ['El password que ha introducido en los dos campos no son iguales.',
				'Por favor, vuelva a introducirlo e inténtelo de nuevo.'],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});
		$("#exampleModal").modal('toggle');

	}
    }

    changePasswordCallBack(response){
        if(response === undefined){
            alert("No se ha podido establecer conexiónn con el servidor");
            return;
        }
        
        if(response.auth === false){
            alert("Hubo un problema con la autenticacióCn, las credenciales no son correctas.");
            return;
        }

        if(response.status === 'OK'){
		this.props.setModalContent({
			title: 'Mensaje del servidor',
			body: ['El password fue actualizado correctamente'],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', callback:() => {this.navigateTo('/login')}, close: true}
			]
		});
		$("#exampleModal").modal('toggle');
        }
    }

    formStyle = {
        margin: '20px auto',
        paddingTop: "70px",
        border: '3px solid gray',
        width: '400px',
        height: 'auto',
        textAlign: "center",
        borderRadius:"10px",
        background:"#CCC"
      };

    inputStyle = {
        padding:"5px",
        marginTop:"5px",
        width: "80%",
        borderRadius: "10px"
    }

    buttonDivStyle = {
        width:"95%",
        paddingTop:"15px",
        textAlign:"center"
    }

    buttonStyle = {
        padding:"5px",
        borderRadius: "5px",
        background: "#FFF"
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
